import axios from "axios";
import ENV from "../../../environment";

export default {
  state: {
    texts: {}
  },

  mutations: {
    addTexts(state, texts) {
      state.texts = texts;
    },
  },

  actions: {
    async fetchContent({ commit }) {
      let options = await axios.get(ENV.baseUrl + ENV.sheetsEndpoint + "?range=Inhalte!A1:D20" + "&pluginSetPreview=" + ENV.setPreview);
      if (!options.data) return;

      let headers = options.data.shift(); // Get the first row, which contains the header names
      let texts = {};

      options.data.forEach((row, index) => {
        let rowAsObject = {};
        headers.forEach((header, index) => (rowAsObject[header] = row[index]));

        row = rowAsObject;

        texts[row["Sektion"]] = row["Beschreibung"];
      });

      commit('addTexts', texts);
    },

  },
};
